import { render, staticRenderFns } from "./free-item-per-amount-edit.vue?vue&type=template&id=aa302f5e"
import script from "./free-item-per-amount-edit.vue?vue&type=script&lang=js"
export * from "./free-item-per-amount-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports